import { Suspense, lazy } from 'react';
import { useParallax } from '@/hooks/useParallax';

const NightWindParticles = lazy(() => import('@/components/three/NightWindParticles'));

const HeroSection = () => {
  const { scrollY, isMobile } = useParallax();

  return (
    <div className="relative min-h-screen flex items-end overflow-hidden">
      {/* 深緑〜ターコイズの低照度グラデーション背景 */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#031D1A] via-[#042A24] to-[#0A3A36]" />
      
      {/* 透明ノイズオーバーレイ */}
      <div className="absolute inset-0 opacity-[0.03]" style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)'/%3E%3C/svg%3E")`,
      }} />
      
      {/* 夜風の粒子アニメーション */}
      <div className="absolute inset-0">
        <Suspense fallback={null}>
          <NightWindParticles className="w-full h-full" />
        </Suspense>
      </div>
      
      {/* 縦書きラベル - 右上に配置 */}
      <div className="absolute right-8 md:right-16 top-28 z-10 group">
        <p className="text-[10px] font-display tracking-[0.4em] text-foreground/25 writing-mode-vertical group-hover:text-foreground/40 group-hover:tracking-[0.5em] transition-all duration-700 ease-out">
          QUIET SPACE
        </p>
      </div>

      {/* 左下にズラしたメインコンテンツ */}
      <div 
        className="relative z-10 w-full px-8 md:px-12 lg:px-24 pb-32 md:pb-48"
        style={{
          transform: `translateY(${isMobile ? 0 : -scrollY * 0.1}px)`,
        }}
      >
        <div className="max-w-5xl space-y-16">
          {/* ブランドコピー */}
          <h1 className="text-2xl md:text-4xl font-display font-light text-foreground/90 tracking-[0.2em] breathing-text">
            変わってる。
          </h1>
          
          {/* キャッチコピー - グラスカード */}
          {/* <div className="ml-4 md:ml-16 max-w-lg">
            <div className="glass-card px-8 py-6 group">
              <p className="text-base md:text-lg text-foreground/60 leading-[2] font-light tracking-[0.08em] group-hover:tracking-[0.1em] transition-all duration-700 ease-out">
                何か置いていく場所がほしくて、こういう形になりました。
              </p>
            </div>
          </div> */}
        </div>
      </div>

      {/* 斜めの装飾ライン - 右下 */}
      <div className="absolute bottom-32 right-12 md:right-24 transform rotate-45 group">
        <div className="w-px h-20 bg-foreground/10 group-hover:h-24 group-hover:bg-foreground/15 transition-all duration-700 ease-out" />
      </div>
      
      {/* 小さな点 - 左上 */}
      <div className="absolute top-1/3 left-1/4">
        <div className="w-1 h-1 bg-primary/20 rounded-full animate-pulse" style={{ animationDuration: '5s' }} />
      </div>
    </div>
  );
};

export default HeroSection;